import jquery from 'jquery';
import wwdev from '@wwdev/functions';
import * as bootstrap from 'bootstrap';

window.$ = window.jQuery = window.jquery = jquery;
window.wwdev = wwdev;
window.bootstrap = bootstrap;

$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	}
});
